import React from 'react';
import { Link } from '@naf-simba/elements-links';
import { Text, TextVariant } from '@naf/text';
import BenefitList from './BenefitList/BenefitList';
import * as S from './NewRelatedBenefits.styles';

type RelatedBenefitsProps = {
  relatedContent: [];
};

const RelatedBenefits = ({ relatedContent }: RelatedBenefitsProps) => (
  <>
    <S.ReadMoreWrapper>
      <Text tag="h2" variant={TextVariant.Header3}>
        Relevante fordeler
      </Text>
      <Link text="Se alle medlemsfordeler" to="/medlemskap/medlemsfordeler" />
    </S.ReadMoreWrapper>
    <BenefitList benefitItems={relatedContent} />
  </>
);

export default RelatedBenefits;
